import { Component, OnInit, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { VisitorSearch } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { VisitorSearchCharLimit } from '../../Models/EnumModels';

@Component({
    selector: 'VisitorSearchPopup',
    templateUrl: './VisitorSearchPopup.html',
    encapsulation: ViewEncapsulation.None,
    styles: [`
    .popup-left  .modal-dialog {
        margin: 5.75rem 0 1.75rem 4rem;
    }
  `]
})

export class VisitorSearchPopup extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    PropertyId: number;
    SelectedId: number;
    RequestModel: VisitorSearch;
    Model: Array<GuestLookup> = null;
    Keyword: string = "";
    ModalRef: NgbModalRef;
    guestlst: Array<GuestLookup> = [];
    allGuestlst: Array<GuestLookup> = [];
    IsLoaded: boolean = false;
    @Output() SelectionChanged: EventEmitter<GuestLookup> = new EventEmitter<GuestLookup>();

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected pmsService: PMSService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
        this.RequestModel = new VisitorSearch();
    }

    ngOnInit(): void {}

    Open(model: any): void {
        this.RequestModel = new VisitorSearch();
        if(model){
            if(model.FName && model.FName.length >= VisitorSearchCharLimit.FName){
                this.RequestModel.FirstName = model.FName; 
            }
             if(model.LName && model.LName.length >= VisitorSearchCharLimit.LName){
                this.RequestModel.LastName = model.LName; 
            }
             if(model.Email && model.Email.length >= VisitorSearchCharLimit.Email){
                this.RequestModel.EmailId = model.Email; 
            }
             if(model.MobileNumber && model.MobileNumber.length >= VisitorSearchCharLimit.MobileNumber){
                this.RequestModel.MobileNumber = model.MobileNumber; 
            }
            if(model.PropertyId){
                this.RequestModel.PropertyId = model.PropertyId;
            }
        }
        this.Model = null;
        this.IsLoaded = false;
        let ngbModalOptions: NgbModalOptions;
        this.onSubmit();
            ngbModalOptions = {
                backdrop: 'static',
                size: 'lg',
                centered: true
            };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
    }

    onSubmit(): void {
        this.Model = null;
        this.SetData();
    }

    onPageChange(): void {
        this.SetData();
    }

    SetData(): void {
        this.SubmitStart();
        this.pmsService.VisitorLookup_Search(this.RequestModel).then((data: any) => {
            this.IsLoaded = false;
            this.Model = data;
            this.SubmitEnd();
        }, err => {
             this.SubmitEnd();
            this.IsLoaded = false;
            this.Model = null;
        });
    }

    onSelect(row: GuestLookup) : void {
        this.SelectionChanged.emit(row);
        this.onClose();
    }

    onClose() {
        this.ModalRef.close();
    }

}
